var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.bottom",value:(_vm.info),expression:"info",modifiers:{"hover":true,"bottom":true}}],attrs:{"value":true,"unchecked-value":false,"variant":_vm.get_variant},on:{"click":_vm.set_value}},[_c('i',{staticClass:"bi bi-plus-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }